<template>

  <div class="workspace">
    <div class="section-heading">
      <h2>Connections</h2>
    </div>
    <div class="static-area">
      <div class="row">
        <div class="col social-box mr-12 mb-12">
          <div class="social-box-heading ">
            <h3><i class="fab fa-google"></i> Google My Business</h3>
            <hr style="border: none;border-top: 1px solid #C8D2D2;margin: 0 0px;">
          </div>
          <div class="social-box-options">
            <p>Copy and paste your <strong>GMB</strong> profile link below.</p>
            <input class="al-input" type="text" v-model="google" placeholder="Paste your link here..."  />

            <div class="social-box-save">
              <div class="social-button" @click="submitForm('google_places', google)"><i class="fas fa-save"></i> Save</div>
              <div class="social-help"><a @click="removeLink('google_places')" href="#" class="red-text"><i class="fas fa-eraser"></i> Remove Link</a></div>
            </div>
          </div>
        </div>
        <div class="col social-box mb-12">
          <div class="social-box-heading ">
            <h3><i class="fab fa-facebook-square"></i> Facebook</h3>
            <hr style="border: none;border-top: 1px solid #C8D2D2;margin: 0 0px;">
          </div>
          <div class="social-box-options">
            <p>Copy and paste your <strong>Facebook</strong> profile link below.</p>
            <input class="al-input" type="text" v-model="facebook" placeholder="Paste your link here..."  />
            <div class="social-box-save">
              <div class="social-button" @click="submitForm('facebook', facebook)"><i class="fas fa-save"></i> Save</div>
              <div class="social-help"><a @click="removeLink('facebook')" href="#" class="red-text"><i class="fas fa-eraser"></i> Remove Link</a></div>
            </div>
          </div>
        </div>
        <div class="col social-box mr-12 mb-12">
          <div class="social-box-heading ">
            <h3><i class="fab fa-instagram"></i> Instagram</h3>
            <hr style="border: none;border-top: 1px solid #C8D2D2;margin: 0 0px;">
          </div>
          <div class="social-box-options">
            <p>Copy and paste your <strong>Instagram</strong> profile link below.</p>
            <input class="al-input" type="text" v-model="instagram" placeholder="Paste your link here..."  />
            <div class="social-box-save">
              <div class="social-button" @click="submitForm('instagram', instagram)"><i class="fas fa-save"></i> Save</div>
              <div class="social-help"><a @click="removeLink('instagram')" href="#" class="red-text"><i class="fas fa-eraser"></i> Remove Link</a></div>
            </div>
          </div>
        </div>
        <div class="col social-box mb-12">
          <div class="social-box-heading ">
            <h3><i class="fab fa-twitter"></i> Twitter</h3>
            <hr style="border: none;border-top: 1px solid #C8D2D2;margin: 0 0px;">
          </div>
          <div class="social-box-options">
            <p>Copy and paste your <strong>Twitter</strong> profile link below.</p>
            <input class="al-input" type="text" v-model="twitter" placeholder="Paste your link here..."  />
            <div class="social-box-save">
              <div class="social-button" @click="submitForm('twitter', twitter)"><i class="fas fa-save"></i> Save</div>
              <div class="social-help"><a @click="removeLink('twitter')" href="#" class="red-text"><i class="fas fa-eraser"></i> Remove Link</a></div>
            </div>
          </div>
        </div>
        <div class="col social-box mr-12 mb-12">
          <div class="social-box-heading ">
            <h3><i class="fab fa-yelp"></i> Yelp</h3>
            <hr style="border: none;border-top: 1px solid #C8D2D2;margin: 0 0px;">
          </div>
          <div class="social-box-options">
            <p>Copy and paste your <strong>Yelp</strong> profile link below.</p>
            <input class="al-input" type="text" v-model="yelp" placeholder="Paste your link here..."  />
            <div class="social-box-save">
              <div class="social-button" @click="submitForm('yelp', yelp)"><i class="fas fa-save"></i> Save</div>
              <div class="social-help"><a @click="removeLink('yelp')" href="#" class="red-text"><i class="fas fa-eraser"></i> Remove Link</a></div>
            </div>
          </div>
        </div>
        <div class="col social-box mb-12">
          <div class="social-box-heading ">
            <h3><i class="fab fa-tiktok"></i> Tiktok</h3>
            <hr style="border: none;border-top: 1px solid #C8D2D2;margin: 0 0px;">
          </div>
          <div class="social-box-options">
            <p>Copy and paste your <strong>Tiktok</strong> profile link below.</p>
            <input class="al-input" type="text" v-model="tiktok" placeholder="Paste your link here..."  />
            <div class="social-box-save">
              <div class="social-button" @click="submitForm('tiktok', tiktok)"><i class="fas fa-save"></i> Save</div>
              <div class="social-help"><a @click="removeLink('tiktok')" href="#" class="red-text"><i class="fas fa-eraser"></i> Remove Link</a></div>
            </div>
          </div>
        </div>
        <div class="col social-box mr-12 mb-12">
          <div class="social-box-heading ">
            <h3><i class="fab fa-linkedin"></i> Linkedin</h3>
            <hr style="border: none;border-top: 1px solid #C8D2D2;margin: 0 0px;">
          </div>
          <div class="social-box-options">
            <p>Copy and paste your <strong>Linkedin</strong> profile link below.</p>
            <input class="al-input" type="text" v-model="linkedin" placeholder="Paste your link here..."  />
            <div class="social-box-save">
              <div class="social-button" @click="submitForm('linkedin', linkedin)"><i class="fas fa-save"></i> Save</div>
              <div class="social-help"><a @click="removeLink('linkedin')" href="#" class="red-text"><i class="fas fa-eraser"></i> Remove Link</a></div>
            </div>
          </div>
        </div>
        <div class="col social-box mb-12">
          <div class="social-box-heading ">
            <h3><i class="fab fa-youtube"></i> Youtube</h3>
            <hr style="border: none;border-top: 1px solid #C8D2D2;margin: 0 0px;">
          </div>
          <div class="social-box-options">
            <p>Copy and paste your <strong>Youtube</strong> profile link below.</p>
            <input class="al-input" type="text" v-model="youtube" placeholder="Paste your link here..."  />
            <div class="social-box-save">
              <div class="social-button" @click="submitForm('youtube', youtube)"><i class="fas fa-save"></i> Save</div>
              <div class="social-help" ><a  @click="removeLink('youtube')" href="#" class="red-text"><i class="fas fa-eraser"></i> Remove Link</a></div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script>


export default {
  data () {
    return {
      name: '',
      email: '',
      google: '',
      yelp: '',
      facebook: '',
      instagram: '',
      youtube: '',
      linkedin: '',
      twitter: '',
      tiktok: '',
      old_pwd: '',
      new_pwd: '',
      new_pwd2: ''

    }
  },
  metaInfo () {
    return {
      title: 'Connections',
      titleTemplate: '%s - AuthorizeLocal',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Manage your social network information'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Local SEO Solutions'
        }
      ]
    }
  },
  components: {
  },
  mounted () {
    this.loadData()
  },
  watch: {
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    loadData () {
      const {name, google_places, yelp, instagram, facebook, twitter, tiktok, linkedin, youtube} = this.activeUserInfo
      if (name || name) {
        this.name = name
      }
      if (google_places || google_places) {
        this.google = google_places
      }
      if (yelp || yelp) {
        this.yelp = yelp
      }
      if (instagram) {
        this.instagram = instagram
      }
      if (facebook) {
        this.facebook = facebook
      }
      if (twitter) {
        this.twitter = twitter
      }
      if (tiktok) {
        this.tiktok = tiktok
      }
      if (linkedin) {
        this.linkedin = linkedin
      }
      if (youtube) {
        this.youtube = youtube
      }
    },
    logout () {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('accessToken')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push('/login').catch(() => {})
    },
    submitForm (field, value) {
      const user = {
        id: this.activeUserInfo._id
      }
      user[field] = value
      console.log('patch payload', user)
      this.$vs.loading()
      this.$store.dispatch('patchUser', user)
        .then(result => {
          if (result) {
            console.log(result)
            this.$vs.notify({
              title: 'Success',
              text: 'Information saved successfully',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-check'
            })
            this.$vs.loading.close()
          }
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
          this.$vs.loading.close()
        })
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to remove this content?',
        accept,
        cancel
      })
    },
    removeLink (field) {
      this.openConfirm(() => {
        const user = {
          id: this.activeUserInfo._id
        }
        user[field] = ''
        console.log('patch payload', user)
        this.$vs.loading()
        this.$store.dispatch('patchUser', user)
          .then(result => {
            if (result) {
              console.log(result)
              this.$vs.notify({
                title: 'Success',
                text: 'Information saved successfully',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
              })
              this.$vs.loading.close()
              location.reload()
            }
          })
          .catch(error => {
            this.$vs.notify({
              title: 'Error',
              text: error.message,
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
            this.$vs.loading.close()
          })
      }, () => {})
    }
  }
}
</script>
<style lang="scss">
.section-heading{
  border: none;
  h2 {
    color: var(--Main-Color-Main-100, #003451);
    font-variant-numeric: lining-nums proportional-nums;

    /* Heading Styles/H1 */
    font-family: Poppins;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 44px; /* 137.5% */
  }
}
.workspace {
  padding: 20px 60px;
  border: none;
}
.social-box-heading {
  h3 {
    color: var(--Main-Color-Main-100, #003451);
    font-variant-numeric: lining-nums proportional-nums;

    /* Heading Styles/H3 */
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px; /* 150% */
  }
}
.social-box-options {
  p {
    color: var(--Main-Color-Main-100, #003451);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 0.16px;

    strong {
      color: var(--Main-Color-Main-100, #003451);

      /* Paragraph Styles/Paragraph Large */
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
    }
  }
}
.al-input {
  border-radius: 12px;
  border: 1px solid var(--Cold-Gray-Cold-Gray-30, #AEB8B8);
  color: var(--Cold-Gray-Cold-Gray-30, #AEB8B8);
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.social-button {
  background-color: #F08028;
}
.social-button:hover {
  background-color: #f07514;
}
.social-help a.red-text {
  color: #F26464;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;

  /* Button Styles/Button Small */
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 200% */
}
</style>
